import React, {useState, useEffect, useRef, useImperativeHandle, forwardRef} from "react";
import parseHtml from 'html-react-parser';
import apiUrl from '../globals';

const ModalFormV2 = forwardRef(({action, elemId, title, input, isEdit}, ref) => {

    const [isValid, setIsValid] = useState(true);
    const [textBtn, setTextBtn] = useState(parseHtml('<span class="material-symbols-outlined">save</span>&nbsp;Salvar'));
    const [titleText, setTitleText] = useState("Cadastrar "+title);
    const [isOpen, setIsOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    
    const modalRef = useRef(null);
    const formRef = useRef(null);

    // Expor métodos para abrir/fechar o modal via ref
    useImperativeHandle(ref, () => ({
        show: () => {
            setIsOpen(true);
            // Pequeno delay para garantir que o DOM foi atualizado antes de mostrar
            setTimeout(() => setIsVisible(true), 10);
        },
        hide: () => {
            setIsVisible(false);
            setTimeout(() => setIsOpen(false), 150);
        }
    }));

    // Gerenciar visibilidade quando isOpen muda
    useEffect(() => {
        if(isOpen){
            setTimeout(() => setIsVisible(true), 10);
            
            // Quando o modal abre, garantir que os selects sejam preenchidos
            // Isso é necessário porque o modal só é renderizado quando isOpen = true
            // Aguardar um pouco mais para garantir que o DOM foi atualizado
            setTimeout(() => {
                // Verificar se a função loadGoogleAdsAccounts existe e chamá-la
                if(typeof window.loadGoogleAdsAccounts === 'function') {
                    window.loadGoogleAdsAccounts();
                }
            }, 150);
        } else {
            setIsVisible(false);
        }
    }, [isOpen]);

    // Registrar função global para abrir o modal via JavaScript
    useEffect(() => {
        // Criar função global para abrir este modal
        window['openModal_' + elemId] = () => {
            setIsOpen(true);
            setTimeout(() => setIsVisible(true), 10);
        };

        // Desabilitar completamente a inicialização automática do Bootstrap para este elemento
        const disableBootstrapForThisModal = () => {
            const modalElement = document.getElementById(elemId);
            if(modalElement) {
                // Remover qualquer listener do Bootstrap
                if(window.bootstrap && window.bootstrap.Modal) {
                    try {
                        const instance = window.bootstrap.Modal.getInstance(modalElement);
                        if(instance) {
                            instance.dispose();
                        }
                    } catch(e) {
                        // Ignorar
                    }
                }
                
                // Garantir que o elemento não seja detectado como modal Bootstrap
                modalElement.setAttribute('data-custom-modal', 'true');
                modalElement.removeAttribute('data-bs-toggle');
                modalElement.removeAttribute('data-bs-target');
                modalElement.classList.remove('modal', 'fade', 'show');
            }
        };

        // Executar imediatamente quando o componente monta
        setTimeout(disableBootstrapForThisModal, 0);

        // Listener para cliques em botões com data-bs-target apontando para este modal
        // Usar capture phase para interceptar ANTES do Bootstrap processar
        const handleToggleClick = (e) => {
            // Verificar se é um botão que aponta para este modal
            const button = e.target.closest('button[data-bs-target="#' + elemId + '"], a[data-bs-target="#' + elemId + '"]');
            if(button){
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                // Remover atributos do Bootstrap para evitar que ele tente inicializar
                button.removeAttribute('data-bs-toggle');
                disableBootstrapForThisModal();
                setIsOpen(true);
                setTimeout(() => setIsVisible(true), 10);
                return false;
            }
        };

        // Interceptar na fase de captura ANTES de qualquer outro listener
        document.addEventListener('click', handleToggleClick, true); // true = capture phase

        return () => {
            delete window['openModal_' + elemId];
            document.removeEventListener('click', handleToggleClick, true);
        };
    }, [elemId]);

    // Controlar scroll do body quando modal estiver aberto
    useEffect(() => {
        if(isOpen){
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = '0px';
        } else {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }
    }, [isOpen]);

    const validateFrom = async (evt) => {

        let dataArray = [];

        let isValidForm = true;

        for (let i = 0; i < evt.target.length; i++) {

            let attrName = evt.target[i].attributes[0] ? evt.target[i].attributes[0].name : '';
            let inputValue = evt.target[i].value;
            let inputName = evt.target[i].name;
            let inputType = evt.target[i].type;
            let inputTagName = evt.target[i].tagName ? evt.target[i].tagName.toLowerCase() : '';
            let isRequiredAttr = evt.target[i].attributes.required;
            let isChecked = false;

            // Converter vírgula para ponto em campos numéricos (padrão brasileiro)
            if(inputType == "number" && inputValue && inputValue.indexOf(',') !== -1){
                inputValue = inputValue.replace(',', '.');
                evt.target[i].value = inputValue;
            }

            if(typeof evt.target[i].checked != "undefined"){
                isChecked = evt.target[i].checked;
            }

            if(typeof isRequiredAttr !== "undefined" && isRequiredAttr !== "undefined"){    
                // Verificar se é um campo select
                const isSelect = inputTagName === "select" || inputType === "select-one" || inputType === "select-multiple";
                
                // Para campos number, permitir 0 e valores decimais válidos
                if(inputType == "number"){
                    if(inputValue == "" || inputValue === null || inputValue === undefined || isNaN(parseFloat(inputValue))){
                        setIsValid(false);    
                        isValidForm = false;
                    }else{
                        if(inputType != "button" && inputType != "submit" && inputType != "checkbox" && inputType != "radio"){
                            dataArray.push({"name": inputName, "value": inputValue});
                        }else if(inputType == "checkbox" || inputType == "radio"){
                            if(isChecked){
                                dataArray.push({"name": inputName, "value": inputValue});
                                console.log("name: "+inputName+" - isChecked: "+isChecked);
                            }
                        }                  
                    }
                }else if(isSelect){
                    // Para campos select, permitir 0 (pode ser um valor válido, como status inativo)
                    // Apenas bloquear se estiver vazio (sem seleção)
                    if(inputValue == "" || inputValue === null || inputValue === undefined){
                        setIsValid(false);    
                        isValidForm = false;
                    }else{
                        // Permitir 0 como valor válido para selects (ex: status inativo = 0)
                        dataArray.push({"name": inputName, "value": inputValue});
                        console.log("Select " + inputName + " com valor:", inputValue);
                    }
                }else if(inputValue == "" || inputValue == 0 || inputValue == "0"){
                    setIsValid(false);    
                    isValidForm = false;
                }else{
                    if(inputType != "button" && inputType != "submit" && inputType != "checkbox" && inputType != "radio"){
                        dataArray.push({"name": inputName, "value": inputValue});
                    }else if(inputType == "checkbox" || inputType == "radio"){
                        if(isChecked){
                            dataArray.push({"name": inputName, "value": inputValue});
                            console.log("name: "+inputName+" - isChecked: "+isChecked);
                        }
                    }                  
                }                
            }else{
                // Campos não obrigatórios - verificar se é select para permitir 0
                const isSelect = inputTagName === "select" || inputType === "select-one" || inputType === "select-multiple";
                
                if(isSelect){
                    // Para selects não obrigatórios, sempre adicionar o valor (pode ser 0)
                    dataArray.push({"name": inputName, "value": inputValue});
                }else if(inputType != "button" && inputType != "submit" && inputType != "checkbox" && inputType != "radio"){
                    dataArray.push({"name": inputName, "value": inputValue});
                }else if(inputType == "checkbox" || inputType == "radio"){                   
                    if(isChecked){
                        dataArray.push({"name": inputName, "value": inputValue});
                        console.log("name: "+inputName+" - isChecked: "+isChecked);
                    }
                }  
            }
        }

        if(isValidForm){   
            await submitForm(evt, dataArray);
        }else{
            evt.preventDefault();
        }
        
    }

    const submitForm = async (evt, dataArray) =>{
        evt.preventDefault();
        
        try {
            const response = await fetch(apiUrl+'/'+action, {
                                        method: "POST",
                                        body: JSON.stringify(dataArray),
                                        headers: {
                                            "Content-Type": "application/json",
                                            "Accept": "*/*",
                                        } 
                                    });                   
            const json = await response.json();

            let successMsg = 'Cadastro realizado com sucesso.';

            if(isEdit){
                successMsg = 'Registro atualizado com sucesso';
            }

            if(json == 1){
                handleClose();
                // Limpar formulário
                if(formRef.current){
                    formRef.current.reset();
                }
                window.$('.toast').find('.toast-body').html(successMsg);
                window.$('.toast').toast('show');
                window.$('.dataTables').DataTable().ajax.reload();
            }else if(json == 0){
                window.$('.toast').find('.toast-body').html('Erro ao efetuar cadastro, tente novamente mais tarde.');
                window.$('.toast').toast('show');
            }else if(json == 2){
                window.$('.toast').find('.toast-body').html('Já existe um cadastro com os mesmos dados, verifique e tente novamente');
                window.$('.toast').toast('show');
            }
            
            if(action == "save-vertical-account"){
                window.$("#id_account").remove();
                window.$("#loadingAccountByPlatform").find('option').eq(0).prop('selected', true);
            }

        }catch(error){
            console.error(error);
        }finally{
         
        }

    }

    useEffect(() => {
        if(isEdit){
            setTextBtn(parseHtml('<span class="material-symbols-outlined">save</span>&nbsp;Atualizar'));
            setTitleText("Atualizar "+title);
        }
    }, [isEdit, title]);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => setIsOpen(false), 150);
    };

    // Estilos inline para o modal customizado
    const modalStyles = {
        display: isOpen ? 'block' : 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1050,
        overflow: 'auto',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.15s linear'
    };

    const backdropStyles = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1040,
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.15s linear'
    };

    const dialogStyles = {
        position: 'relative',
        width: 'auto',
        maxWidth: '800px',
        margin: '1.75rem auto',
        zIndex: 1051,
        transform: isVisible ? 'scale(1)' : 'scale(0.95)',
        transition: 'transform 0.15s ease-out'
    };

    // Efeito para prevenir que o Bootstrap detecte este elemento como modal quando renderizado
    useEffect(() => {
        const modalElement = document.getElementById(elemId);
        if(modalElement && window.bootstrap && window.bootstrap.Modal) {
            // Interceptar e prevenir qualquer tentativa do Bootstrap de inicializar
            const preventBootstrapInit = (e) => {
                if(e.target && (e.target.id === elemId || e.target.closest('#' + elemId))) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                }
            };
            
            // Adicionar listeners para prevenir inicialização
            modalElement.addEventListener('click', preventBootstrapInit, true);
            document.addEventListener('click', (e) => {
                const button = e.target.closest('[data-bs-target="#' + elemId + '"]');
                if(button && button.hasAttribute('data-bs-toggle')) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    button.removeAttribute('data-bs-toggle');
                    return false;
                }
            }, true);
            
            // Destruir qualquer instância existente
            try {
                const instance = window.bootstrap.Modal.getInstance(modalElement);
                if(instance) {
                    instance.dispose();
                }
            } catch(e) {
                // Ignorar
            }
            
            return () => {
                modalElement.removeEventListener('click', preventBootstrapInit, true);
            };
        }
    }, [elemId]);

    // Efeito para garantir que o elemento nunca seja detectado pelo Bootstrap
    // Executar ANTES de renderizar o elemento
    useEffect(() => {
        // Garantir que o elemento tenha o atributo ANTES de ser renderizado
        // Isso será aplicado quando o elemento for criado
        const ensureProtection = () => {
            const modalElement = document.getElementById(elemId);
            if(modalElement) {
                // Garantir atributos que impedem o Bootstrap de detectar
                modalElement.setAttribute('data-custom-modal', 'true');
                modalElement.removeAttribute('data-bs-toggle');
                modalElement.removeAttribute('data-bs-target');
                modalElement.removeAttribute('tabindex');
                modalElement.classList.remove('modal', 'fade', 'show');
                
                // Destruir qualquer instância do Bootstrap imediatamente
                if(window.bootstrap && window.bootstrap.Modal) {
                    try {
                        const instance = window.bootstrap.Modal.getInstance(modalElement);
                        if(instance && instance !== window.bootstrapProtection?.mockModalInstance) {
                            instance.dispose();
                        }
                    } catch(e) {
                        // Ignorar
                    }
                }
            }
        };
        
        // Executar imediatamente e também quando o elemento for renderizado
        if(isOpen) {
            setTimeout(ensureProtection, 0);
            const interval = setInterval(() => {
                ensureProtection();
            }, 50);
            
            return () => clearInterval(interval);
        }
    }, [elemId, isOpen]);

    if(!isOpen) return null;

    return (
        <>
            {/* Backdrop */}
            <div 
                className="custom-modal-backdrop"
                style={backdropStyles}
                onClick={handleClose}
            />
            
            {/* Modal */}
            <div 
                ref={(el) => {
                    modalRef.current = el;
                    // Aplicar proteção imediatamente quando o elemento é criado
                    if(el) {
                        el.setAttribute('data-custom-modal', 'true');
                        el.removeAttribute('data-bs-toggle');
                        el.removeAttribute('data-bs-target');
                        el.removeAttribute('tabindex');
                        el.classList.remove('modal', 'fade', 'show');
                        
                        // Destruir qualquer instância do Bootstrap imediatamente
                        if(window.bootstrap && window.bootstrap.Modal) {
                            try {
                                const instance = window.bootstrap.Modal.getInstance(el);
                                if(instance && instance !== window.bootstrapProtection?.mockModalInstance) {
                                    instance.dispose();
                                }
                            } catch(e) {
                                // Ignorar
                            }
                        }
                    }
                }}
                id={elemId}
                className="custom-modal-wrapper"
                style={modalStyles}
                role="dialog"
                aria-modal="true"
                aria-labelledby={elemId + "Label"}
                data-custom-modal="true"
                onClick={(e) => {
                    // Prevenir que cliques no modal sejam processados pelo Bootstrap
                    if(e.target.id === elemId) {
                        e.stopPropagation();
                    }
                }}
            >
                <div className="custom-modal-dialog" style={dialogStyles}>
                    <div className="custom-modal-content">
                        <form ref={formRef} onSubmit={validateFrom}>
                            <div className="custom-modal-header">
                                <h1 className="custom-modal-title" id={elemId + "Label"}>{titleText}</h1>
                                <button 
                                    type="button" 
                                    className="custom-modal-close" 
                                    onClick={handleClose}
                                    aria-label="Fechar"
                                >×</button>
                            </div>
                            <div className="custom-modal-body">
                                {(() => {
                                    let inputsArray = [];
                                    for(let i = 0; i < input.length; i++){

                                        let html = '';
                                        let requiredAttr = '';

                                        if(input[i].isRequired){
                                            requiredAttr = 'required';
                                        }

                                        if(input[i].type == 'select'){

                                            html += '<div class="mb-3" key="'+i+'">'+
                                                        '<label for="'+input[i].name+'" class="form-label">'+input[i].label+'</label>'+
                                                        '<select id="'+input[i].id+'" '+requiredAttr+' class="selectInput form-control" name="'+input[i].name+'" defaultValue="'+input[i].value+'">';

                                            for(let k = 0; k < input[i].options.length; k++){
                                                html += '<option value="'+input[i].options[k].value+'">'+input[i].options[k].text+'</option>';                                   
                                            }

                                            html += '</select>';

                                        }else if(input[i].type == 'textarea'){

                                            html += '<div class="mb-3" key="'+i+'">'+
                                                        '<label for="'+input[i].name+'" class="form-label">'+input[i].label+'</label>'+
                                                        '<textarea '+requiredAttr+' class="texareaInput form-control" name="'+input[i].name+'"></textarea>';

                                        }else if(input[i].type == 'radio' || input[i].type == 'checkbox'){

                                            html += '<div class="form-label" key="'+i+'">';
                                            html += '<label for="'+input[i].name+'" class="form-check-label">'+input[i].label+'</label><br />';

                                            for(let j = 0; j < input[i].options.length; j++){
                                                if(input[i].options[j].checked){
                                                    html += '<span class="checkRadioContainer"><input checked type="'+input[i].type+'" class="checkRadioInput form-check-input" value="'+input[i].options[j].value+'" name="'+input[i].name+'[]">&nbsp;'+input[i].options[j].text+'</input></span>&nbsp;&nbsp;';
                                                }else{
                                                    html += '<span class="checkRadioContainer"><input type="'+input[i].type+'" class="checkRadioInput form-check-input" value="'+input[i].options[j].value+'" name="'+input[i].name+'[]">&nbsp;'+input[i].options[j].text+'</input></span>&nbsp;&nbsp;';                                     
                                                }
                                            }

                                            html +=  "<br /><hr />";

                                        }else{

                                            let stepAttr = '';
                                            if(input[i].type == "number"){
                                                if(input[i].step){
                                                    stepAttr = ' step="'+input[i].step+'"';
                                                }else{
                                                    stepAttr = ' step="any"';
                                                }
                                            }

                                            if(input[i].type == "password" && isEdit){
                                                html += '<div class="mb-3" key="'+i+'">'+
                                                        '<label for="'+input[i].name+'" class="form-label">'+input[i].label+'</label>'+
                                                        '<input type="'+input[i].type+'" class="normalInput form-control" name="'+input[i].name+'" />';
                                            }else{
                                                html += '<div class="mb-3" key="'+i+'">'+
                                                        '<label for="'+input[i].name+'" class="form-label">'+input[i].label+'</label>'+
                                                        '<input '+requiredAttr+stepAttr+' type="'+input[i].type+'" class="normalInput form-control" name="'+input[i].name+'" />';
                                            }
                                        }

                                        html += '</div>';

                                        html = parseHtml(html);
                                        inputsArray.push(html);
                                    }

                                    return (inputsArray);
                                
                                })()}  
                            </div>
                            <div className="custom-modal-footer">
                                <button type="button" className="btn btn-outline-light" onClick={handleClose}>Fechar</button>
                                <button type="submit" className="btn btn-outline-success">{textBtn}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
});

ModalFormV2.displayName = 'ModalFormV2';

export default ModalFormV2;
